import {
  FETCH_AREA,
  FETCH_AREA_SUCCESS,
  FETCH_AREA_FAIL,
  GET_AREA,
  GET_AREA_SUCCESS,
  GET_AREA_FAIL,
  CREATE_AREA,
  CREATE_AREA_SUCCESS,
  CREATE_AREA_FAIL,
  UPDATE_AREA,
  UPDATE_AREA_SUCCESS,
  UPDATE_AREA_FAIL,
  DELETE_AREA,
  DELETE_AREA_SUCCESS,
  DELETE_AREA_FAIL,
} from 'actions/address';
import * as _ from 'lodash';
import { toast } from 'react-toastify';

const initialState = {
  isLoading: false,
  areas: [],
  areaDetail: {},
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const areaReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_AREA:
    case GET_AREA:
    case CREATE_AREA:
    case DELETE_AREA: {
      return { ...state, isLoading: true, areaDetail: {} };
    }

    case UPDATE_AREA: {
      return { ...state, isLoading: true };
    }

    case FETCH_AREA_SUCCESS: {
      if (payload.page === 1) {
        return {
          ...state,
          isLoading: false,
          areas: payload.results,
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      } else {
        return {
          ...state,
          isLoading: false,
          areas: _.concat(state.areas, payload.results),
          page: payload.page,
          limit: payload.limit,
          totalPages: payload.totalPages,
          total: payload.totalResults,
        };
      }
    }

    case GET_AREA_SUCCESS: {
      return {
        ...state,
        areaDetail: payload,
        isLoading: false,
      };
    }

    case CREATE_AREA_SUCCESS: {
      toast.success('Area added successfully');
      return {
        ...state,
        areas: _.concat(state.areas, payload),
        isLoading: false,
      };
    }

    case UPDATE_AREA_SUCCESS: {
      toast.success('Area updated successfully');
      return {
        ...state,
        isLoading: false,
        areas: state.areas.map((data) => (data.id === payload.id ? payload : data)),
      };
    }

    case DELETE_AREA_SUCCESS: {
      toast.success('Area deleted successfully');
      return {
        ...state,
        isLoading: false,
        areas: state.areas.filter((data) => data.id !== payload),
      };
    }

    case FETCH_AREA_FAIL:
    case GET_AREA_FAIL:
    case CREATE_AREA_FAIL:
    case UPDATE_AREA_FAIL:
    case DELETE_AREA_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }
    default:
      return { ...state };
  }
};
export default areaReducer;
